export default "__VITE_ASSET__Bz4dxjez__"